// import { MenuItem } from '@shared/menu-items/model'
import { ExternalPaths, Paths } from '@shared/menu-items/paths'

export const topMenuItems = [
	{
		name: 'Кредиты',
		path: Paths.root,
		items: [
			// {
			// 	name: 'Деньги под залог недвижимости',
			// 	path: Paths.productRealEstate,
			// },
			// {
			// 	name: 'Квартира',
			// 	path: Paths.productApartment,
			// },
			// {
			// 	name: 'Карта сайта',
			// 	path: Paths.sitemap,
			// },
		],
	},
	{
		name: 'Инвестиции',
		path: ExternalPaths.invest,
		items: [
			// 	{
			// 		name: 'Команда',
			// 		path: Paths.notFound,
			// 	},
			// {
			// 	name: 'Платформа',
			// 	path: Paths.platform,
			// },
			// 	{
			// 		name: 'Мы в СМИ',
			// 		path: Paths.notFound,
			// 	},
			// 	{
			// 		name: 'Работа у нас',
			// 		path: Paths.notFound,
			// 	},
			// 	{
			// 		name: 'Структура платформы',
			// 		path: Paths.notFound,
			// 	},
			// 	{
			// 		name: 'Вакансии',
			// 		path: Paths.notFound,
			// 	},
			// 	{
			// 		name: 'Разработчикам',
			// 		path: Paths.notFound,
			// 	},
			// 	{
			// 		name: 'Реферальная программа',
			// 		path: Paths.notFound,
			// 	},
			// 	{
			// 		name: 'Корпоративная жизнь',
			// 		path: Paths.notFound,
			// 	},
		],
	},
	{
		name: 'Банкам',
		path: ExternalPaths.banks,
	},
	{
		name: 'Партнёрам',
		path: Paths.partners,
		items: [],
	},
	{
		name: 'О компании',
		path: Paths.about,
	},
]
